module.exports = __webpack_public_path__ + "assets/3-enterprise-account-exec.a2bba5b2.png";